import {createAction, props} from '@ngrx/store';
import {GlobalMessage} from '../models/global-message';

export const addMessage = createAction(
    '[Global Message] Add',
    props<{ globalMessage: GlobalMessage }>()
);

export const dismissMessage = createAction(
    '[Global Message] Dismiss',
    props<{ globalMessage: GlobalMessage }>()
);

